import { c as _c } from "react/compiler-runtime";
// SWEEPSTAKES (DEV-10675). The campaign banner on the product page.
//
// Artwork rather than a rendered badge: the offer, the prize photo and the
// "*TS & CS APPLY" line are all baked into the PNGs, which is why this carries
// no entry count. The count belongs to `<EntriesBadge>` on the listing tiles.
//
// The offer is therefore an image of text (WCAG 1.4.5), so the alt describes
// the picture and an sr-only line beside it carries the words as real text.
// Cycle 1 put the marketing copy in the alt itself and DEV-9103 had to fix it.
import Image from "next/image";
import { SWEEPSTAKES, announcementFor, isSweepstakesActive, productBannerFor, type SweepstakesState } from "../../lib/const/sweepstakes";
interface SweepstakesProductBannerProps {
  market: string;
  /** Campaign state, resolved on the server. */
  scheduled: SweepstakesState;
  /** Wrapper spacing, so each surface can sit it in its own rhythm. */
  className?: string;
}
export const SweepstakesProductBanner = t0 => {
  const $ = _c(19);
  const {
    market,
    scheduled,
    className: t1
  } = t0;
  const className = t1 === undefined ? "mt-4" : t1;
  if (!isSweepstakesActive(market, scheduled)) {
    return null;
  }
  let t2;
  if ($[0] !== scheduled) {
    t2 = productBannerFor(scheduled);
    $[0] = scheduled;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const banner = t2;
  let t3;
  if ($[2] !== banner.desktopHeight || $[3] !== banner.desktopSrc || $[4] !== banner.desktopWidth) {
    t3 = <Image alt={SWEEPSTAKES.productBanner.alt} src={banner.desktopSrc} width={banner.desktopWidth} height={banner.desktopHeight} sizes="(max-width: 768px) 100vw, 50vw" className="hidden h-auto w-full md:block" />;
    $[2] = banner.desktopHeight;
    $[3] = banner.desktopSrc;
    $[4] = banner.desktopWidth;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== banner.mobileHeight || $[7] !== banner.mobileSrc || $[8] !== banner.mobileWidth) {
    t4 = <Image alt={SWEEPSTAKES.productBanner.alt} src={banner.mobileSrc} width={banner.mobileWidth} height={banner.mobileHeight} sizes="100vw" className="block h-auto w-full md:hidden" />;
    $[6] = banner.mobileHeight;
    $[7] = banner.mobileSrc;
    $[8] = banner.mobileWidth;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== scheduled) {
    t5 = announcementFor(scheduled);
    $[10] = scheduled;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <span className="sr-only">{t5} {SWEEPSTAKES.termsNote}</span>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== className || $[15] !== t3 || $[16] !== t4 || $[17] !== t6) {
    t7 = <div className={className}>{t3}{t4}{t6}</div>;
    $[14] = className;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};